'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRssFeed = function MdRssFeed(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6.6 16.8c9.2 0 16.6 7.4 16.6 16.6h-4.8c0-6.5-5.3-11.8-11.8-11.8v-4.8z m0-9.4c14.3 0 26 11.7 26 26h-4.7c0-11.8-9.5-21.3-21.3-21.3v-4.7z m0 22.3c0-2 1.7-3.6 3.7-3.6s3.6 1.6 3.6 3.6-1.6 3.7-3.6 3.7-3.7-1.7-3.7-3.7z' })
        )
    );
};

exports.default = MdRssFeed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/rss-feed.js
// module id = 2732
// module chunks = 0